import styles from '@components/modules/ProductGrid/Filter/FilterCheckbox.module.scss'
import clsx from 'clsx'
import { FC } from 'react'

export type CheckBoxOption = {
  label: string
  value: string
  count?: number
  disabled?: boolean | false
}

type FilterCheckboxProps = {
  name: string
  options: CheckBoxOption[]
  selectedOptions: CheckBoxOption[]
  onChange: (options: CheckBoxOption[]) => void
  onClick: () => void
  isListOpen?: boolean | false
}

const FilterCheckbox: FC<FilterCheckboxProps> = ({
  name,
  options,
  selectedOptions,
  onChange,
  onClick,
  isListOpen,
}) => {
  return (
    <div className={clsx(styles.filterContainer)}>
      <div className={styles.filterSection} onClick={() => onClick()}>
        <div className="paragraphOne">{name}</div>
        <span
          className={`${styles.expandButtonIcon} ${
            isListOpen && styles.active
          }`}
        >
          <span className={styles.expandButtonLine}></span>
          <span
            className={`${styles.expandButtonLine} ${styles.expandButtonLineRotate}`}
          ></span>
        </span>
      </div>
      <div className={styles.optionsWrapper}>
        <div
          className={clsx(styles.filterOptions, {
            [styles.open]: isListOpen,
          })}
        >
          {options?.map((option, index) => (
            <div key={index} className={styles.checkbox}>
              <input
                type="checkbox"
                id={option.value}
                name={option.value}
                disabled={option.count === 0}
                checked={selectedOptions.some((o) => o.value === option.value)}
                onChange={(e) =>
                  onChange(
                    e.target.checked
                      ? [...selectedOptions, option]
                      : selectedOptions.filter((o) => o.value !== option.value),
                  )
                }
              />
              <label htmlFor={option.value}>
                <div className={styles.labelName}>
                  {option.label.replace(/-/gm, ' ')}
                </div>
                <div className={styles.labelCount}>
                  {option.count && `${option.count}`}
                </div>
              </label>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default FilterCheckbox
